import styled from "styled-components";

export const TableHeaderRow = styled.tr`
  text-align: left;
  border-bottom: 2px solid #414141;

  th {
    padding: 10px;
  }
`;

export const TableRow = styled.tr`
  &:hover {
    background-color: #f5f5f5;
  }

  td {
    padding: 10px;
    border-bottom: 1px solid #bababa;

    .done-button {
      opacity: 0.3;
    }

    &:hover .done-button {
      opacity: 1;
    }
  }
`;
